import { Component, OnDestroy, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { Observable, Subscription } from 'rxjs';
import { InspeccionService } from 'src/app/services/inspeccion.service';
import { ObservableInspService } from 'src/app/services/observable_insp';

@Component({
  selector: 'app-resumen-insp',
  templateUrl: './resumen-insp.component.html',
  styleUrls: ['./resumen-insp.component.css'],
  providers: [InspeccionService]
})
export class ResumenInspComponent implements OnInit, OnDestroy {

  constructor(private dialog: MatDialog
    , private observableService: ObservableInspService, private _inspeccionService: InspeccionService, private _router: Router, private spinner: NgxSpinnerService) { }
  rutSolicitante;
  dvSolicitante;
  direccionSolicitante;
  folioDire;
  folioPredio;
  comentario;
  siglas;
  urlZip = null;
  correo;
  tipoInsp;
  dataInsert;
  correoDestroy: Subscription;
  usuarioDestroy: Subscription;
  direccionDestroy: Subscription;
  siglasIdDestroy: Subscription;
  tiposInspDestroy: Subscription;
  folioDireDestroy: Subscription;
  folioPredioDestroy: Subscription;
  comentarioDestroy: Subscription;
  @ViewChild('finalizarMSG') finalizarMSG: TemplateRef<any>;

  ingresando = false

  ngOnInit(): void {

    // CARGO DATA QUE UTILIZARÉ EN LA CREACION DE LA INSPECCIÓN
    this.correoDestroy = this.observableService.correo$.subscribe(corr => {
      this.correo = corr;
      console.log('valor necesario ', this.comentario);

    });

    this.usuarioDestroy = this.observableService.usuario$.subscribe(resp => {

      
      var fullRut = resp.split("-");

      this.rutSolicitante = fullRut[0];
      this.dvSolicitante = fullRut[1];
      console.log('usuario$.subscribe valor necesario ', this.rutSolicitante);
    });
    this.direccionDestroy = this.observableService.direccion$.subscribe(dir => {
      this.direccionSolicitante = dir;
      console.log('valor necesario ', this.direccionSolicitante);

    });
    this.siglasIdDestroy = this.observableService.siglasId$.subscribe(sig => {
      // this.siglas = sig;
      this.siglas = sig.toString().toLowerCase();







    });
    this.tiposInspDestroy = this.observableService.tiposInsp$.subscribe(sig => {
      this.tipoInsp = sig;
      console.log('valor necesario ', this.tipoInsp);

    });
    this.folioDireDestroy = this.observableService.folioDire$.subscribe(fol => {
      this.folioDire = fol;
      console.log('valor necesario ', this.folioDire);

    });
    this.folioPredioDestroy = this.observableService.folioPredio$.subscribe(pre => {
      this.folioPredio = pre

    });
    this.comentarioDestroy = this.observableService.comentario$.subscribe(com => {

      this.comentario = com;
      // this.comentario = '<strong>Observación : </strong> <br> ';
      // const arr = com.split('');
      // console.log('com:: ', com);
      // const sum = 30;
      // let contador = sum;
      // for (let i = 0; i < arr.length; i++) {
      //   this.comentario += arr[i];
      //   if (i === contador) {
      //     this.comentario += '<br>';
      //     console.log('this.comentario:: ', this.comentario);
      //     contador = contador + sum;
      //     console.log('contador:: ', contador);
      //   }
      // }

      console.log('valor necesario ', this.comentario);

    });
    //////////////////////////////////////////////////////////////
  }
  ngOnDestroy() {
    this.usuarioDestroy.unsubscribe();
    this.direccionDestroy.unsubscribe();
    this.siglasIdDestroy.unsubscribe();
    this.tiposInspDestroy.unsubscribe();
    this.folioDireDestroy.unsubscribe();
    this.folioPredioDestroy.unsubscribe();
    this.comentarioDestroy.unsubscribe();
  }
  crearSolicitudInspeccion() {
    this.spinner.show()
    // console.log('siglas', this.siglas);
    // console.log('tipos insp', this.tipoInsp);
    // console.log('rut sol', this.rutSolicitante, this.dvSolicitante);
    // console.log('direccion sol', this.direccionSolicitante);
    // console.log('folio predio', this.folioPredio);
    // console.log('folio dire ', this.folioDire);
    // console.log('comentario', this.comentario);
    this.ingresando = true

    this.urlZip = localStorage.getItem("ZipURL");
    console.log('var url ', this.urlZip);
    this.dataInsert = [];
    this.dataInsert = this.dataInsert.concat({
      direccion: this.direccionSolicitante,
      folio_predio: this.folioPredio,
      folio_direccion: this.folioDire,
      rut_solicitante: this.rutSolicitante,
      dv_solicitante: this.dvSolicitante,
      siglas_id: this.siglas,
      observacion: this.comentario,
      tipo_insp: this.tipoInsp,
      url: this.urlZip,
      correo: this.correo
    })
    console.log('data::::', this.dataInsert);

    this._inspeccionService.crearInspeccion(this.dataInsert[0]).subscribe(
      (response) => {
        console.log('response complet', response);
        console.log('ahora ');
        localStorage.removeItem("archivos_marcados")
        localStorage.removeItem("ZipURL")
        localStorage.removeItem("adjuntos")
        this.spinner.hide()
        this.dialog.open(this.finalizarMSG, { disableClose: true })
      

      },


      (error) => {
        this.spinner.hide()
        this.ingresando = false
        console.log(' NO GRABO RESPONSE', error);

        localStorage.removeItem("archivos_marcados")
        localStorage.removeItem("ZipURL")
        localStorage.removeItem("adjuntos")
        let alert = { icon: 'success', text: '', title: '' }

        alert.icon = 'alert'
        alert.text = '<p>Revise los datos ingresados.<br><br><br><br><br></p>'
        alert.title = 'ERROR'


        // this._router.navigate(['/inicio']);


      }
    );



  }




  finalizarBTN() {
    this._router.navigate([`/inicio`]);
    this.dialog.closeAll();
  }



}
